// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchRightholdersView__breadCrumbs"};